// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1gmL_","title":"Images90_title__2FaRQ","images":"Images90_images__1Uaaw"};